export const DEFAULT_DATE_FIELD_FORMAT = "YYYY-MM-DD";
export const AMOUNT_OF_DAY_ADDED_TO_DEADLINE = 7;
export const AMOUNT_OF_DAY_ADDED_TO_PUBLISH_DATE = 5;
export const START_TIME_STRING = "00:00:00";
